const MapsInit = () => {
    const mapElements = Array.prototype.slice.call(
        document.querySelectorAll(".google-map")
    );

    if (!mapElements) return;

    mapElements.forEach((mapElement) => {
        const marker = mapElement.querySelector(".marker");

        const args = {
            zoom: 12,
            center: new google.maps.LatLng(
                mapElement.dataset.lat,
                mapElement.dataset.lng
            ),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
        };

        const map = new google.maps.Map(mapElement, args);

        const gMarker = new google.maps.Marker({
            position: new google.maps.LatLng(
                mapElement.dataset.lat,
                mapElement.dataset.lng
            ),
            map: map,
        });

        // Make info window if the marker has innerHTML
        if (marker.innerHTML) {
            const infoWindow = new google.maps.InfoWindow({
                content: marker.innerHTML,
            });

            // Open infoWindow when marker is clicked
            gMarker.addListener("click", function () {
                infoWindow.open(map, gMarker);
            });
        }

        return map;
    });
};

export default MapsInit;